import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DataMessage } from 'src/app/models/DataMessage';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MessagesService } from 'src/app/services/messages.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';
declare var jQuery: any;


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  nid: string;
  email: string;
  mensaje: string;
  tipoIncidencia: string;
  contactFormValues : DataMessage = new DataMessage();
  emailSelect: string;

  // validación campos formulario contacto
  public contactForm = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.email]),
    mensaje: new FormControl("", Validators.required),
    tipoIncidencia: new FormControl("", Validators.required),
  });

  constructor(private mensajesService: MessagesService,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private authService: AuthenticationService) {

  }

  ngOnInit() {
    jQuery.getScript(CONSTANTES.menu);
  }

  /**
   * Se envian los datos del formulario de contacto
   */
  submitContactForm() {
    this.SpinnerService.show();
    this.contactFormValues = {
      id : null,
      user: null,
      creationDate : null,
      nid: localStorage.getItem("nid"),
      typeEffect: this.emailSelect,
      email: this.contactForm.value["email"],
      question: this.contactForm.value["mensaje"],

    }

    this.mensajesService.postContacto(this.contactFormValues).subscribe(
      data => {
        this.toastr.success('PETICIÓN ENVIADA CORRECTAMENTE');
        if (getToken(data)) {
          this.router.navigate(['home']);

        } else {
          this.toastr.warning("ERROR");
        }
        this.SpinnerService.hide();
      },
      error => {
        this.toastr.error('LA PETICIÓN NO HA PODIDO ENVIARSE CORRECTAMENTE');
        this.SpinnerService.hide();

      })
  }
}
